import gsap from "@resn/gsap"
// import { ExpoScaleEase, RoughEase, SlowMo } from '@resn/gsap/EasePack'
// import { SlowMo } from '@resn/gsap/EasePack'
import { CSSRulePlugin } from "@resn/gsap/CSSRulePlugin"
// import { Draggable } from '@resn/gsap/Draggable'
// import { EaselPlugin } from '@resn/gsap/EaselPlugin'
// import { MotionPathPlugin } from '@resn/gsap/MotionPathPlugin'
// import { PixiPlugin } from '@resn/gsap/PixiPlugin'
// import { TextPlugin } from '@resn/gsap/TextPlugin'
// import { ScrollToPlugin } from '@resn/gsap/ScrollToPlugin'
import { CustomEase } from "@resn/gsap/CustomEase"
// import { CustomBounce } from '@resn/gsap/CustomBounce'
// import { CustomWiggle } from '@resn/gsap/CustomWiggle'
import { ScrollTrigger } from "@resn/gsap/ScrollTrigger"
// import { DrawSVGPlugin } from '@resn/gsap/DrawSVGPlugin'
// import { GSDevTools } from '@resn/gsap/GSDevTools'
// import { InertiaPlugin } from '@resn/gsap/InertiaPlugin'
// import { MorphSVGPlugin } from '@resn/gsap/MorphSVGPlugin'
// import { MotionPathHelper } from '@resn/gsap/MotionPathHelper'
// import { Physics2DPlugin } from '@resn/gsap/Physics2DPlugin'
// import { PhysicsPropsPlugin } from '@resn/gsap/PhysicsPropsPlugin'
// import { ScrambleTextPlugin } from '@resn/gsap/ScrambleTextPlugin'
import { SplitText } from "@resn/gsap/SplitText"
import { TextPlugin } from "@resn/gsap/TextPlugin"

// import { ScrollSmoother } from "gsap/ScrollSmoother"

export default defineNuxtPlugin((nuxtApp) => {
  if (!import.meta.client) return

  gsap.registerPlugin(
    CSSRulePlugin,
    SplitText,
    ScrollTrigger,
    CustomEase,
    TextPlugin
  )

  ScrollTrigger.config({
    ignoreMobileResize: true,
  })

  gsap.defaults({
    // ease: "power1.out",
    overwrite: "auto",
  })

  return {
    provide: {
      gsap,
      ScrollTrigger,
      SplitText,
      CustomEase,
      TextPlugin,
    },
  }
})
